<template>
  <div v-resize="calculateDimensions">
    <div class="fixed-placeholder" :style="{ width: `${width}px`, height: height && `${height}px` }" ref="fixed">
      <component :is="component" v-bind="restOfProps" v-on="$listeners" />
    </div>
    <div class="scale-hide overflow-y" :style="{ height: height && `${height}px` }">
      <component :is="component" v-bind="restOfProps" />
    </div>
  </div>
</template>

<script>
import { propToBool } from '../../../libraries/common';
export default {
  props: ['component', 'horizontal'],
  data() {
    return {
      width: 0,
      height: null,
    };
  },
  computed: {
    restOfProps() {
      var { ...restOfProps } = this.$attrs;
      return restOfProps;
    },
  },
  methods: {
    calculateDimensions() {
      var width = this.$el.offsetWidth;
      if (this.width !== width)
        this.width = width;

      var fixedClientRect = this.$refs.fixed.getBoundingClientRect();
      if (!propToBool(this.horizontal)) {
        var height = window.innerHeight - fixedClientRect.top
        if (this.height !== height)
          this.height = height;
      }
    },
  },
  updated() {
    this.calculateDimensions();
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisFixedPlaceholder'] = this;
    this.$nextTick(this.calculateDimensions);
  },
}
</script>

<style lang="scss" scoped>
.fixed-placeholder {
  overflow-y: auto;
  overflow-x: hidden;
  position: fixed;
  z-index: 1;
}
</style>